import { render, staticRenderFns } from "./Triangle.vue?vue&type=template&id=0282bff8&scoped=true&"
import script from "./Triangle.vue?vue&type=script&lang=ts&"
export * from "./Triangle.vue?vue&type=script&lang=ts&"
import style0 from "./Triangle.vue?vue&type=style&index=0&id=0282bff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0282bff8",
  null
  
)

export default component.exports